import ShrinkMDLink from "./ShrinkMDLink";
import { SHRINK_NETWORK_URL, networkUrl } from "@/lib/site";

export default function FooterDisclaimer() {
  return (
    <section
      aria-label="Educational and crisis disclaimer"
      style={{
        background: "hsl(217 24% 22%)",
        borderBottom: "1px solid hsl(var(--footer-border))",
        borderTop: "3px solid hsl(var(--brand))",
      }}
    >
      <div
        className="mx-auto max-w-[1200px] px-6 py-5 space-y-3 text-sm leading-relaxed"
        style={{ color: "hsl(var(--footer-fg))" }}
      >
        <p style={{ margin: 0 }}>
          <strong style={{ color: "hsl(var(--footer-fg))" }}>
            Educational network only.
          </strong>{" "}
          <a
            href={networkUrl(`${SHRINK_NETWORK_URL}/`, "footer_disclaimer")}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "hsl(var(--footer-fg))" }}
            className="underline hover:no-underline"
          >
            The Shrink Network
          </a>{" "}
          is a coordinated ecosystem of independent mental
          health properties. Every editorial site is medically reviewed by a
          board-certified psychiatrist. Entries on the editorial sites are
          general education, not medical advice. They aren't a substitute for
          evaluation, diagnosis, or treatment by a licensed clinician, and
          reading them doesn't create a doctor-patient relationship. Don't
          start, stop, or change any treatment based on what you read on any
          site in the network without talking to a licensed clinician who knows
          your situation. Read the full{" "}
          <a
            href="/medical-disclaimer"
            style={{ color: "hsl(var(--brand))", textDecoration: "underline" }}
          >
            medical disclaimer
          </a>
          .
        </p>
        <p style={{ margin: 0 }}>
          <strong style={{ color: "hsl(var(--footer-fg))" }}>
            If you're in crisis.
          </strong>{" "}
          Call or text{" "}
          <span style={{ color: "hsl(var(--brand))", fontWeight: 700 }}>
            988
          </span>{" "}
          in the US to reach the Suicide and Crisis Lifeline, available 24 hours
          a day. Call{" "}
          <span style={{ color: "hsl(var(--brand))", fontWeight: 700 }}>
            911
          </span>{" "}
          if someone is in immediate danger. The Suicide and Crisis link at the
          top of every page goes to our{" "}
          <a
            href="/suicide-and-crisis"
            style={{ color: "hsl(var(--brand))", textDecoration: "underline" }}
          >
            crisis and safety resources
          </a>
          .
        </p>
        <p style={{ margin: 0 }}>
          <strong style={{ color: "hsl(var(--footer-fg))" }}>
            AI and editorial oversight.
          </strong>{" "}
          AnxietyResource may use AI-assisted tools to support drafting,
          organization, summarization, grammar review, and editorial
          workflows. AI tools do not independently publish content.
          Medical content is reviewed by a board-certified psychiatrist
          before publication. AI does not replace human review, medical
          judgment, diagnosis, or treatment decisions. Full policy on the{" "}
          <a
            href="/ai-use"
            style={{ color: "hsl(var(--brand))", textDecoration: "underline" }}
          >
            AI use policy
          </a>{" "}
          page.
        </p>
        <p style={{ margin: 0 }}>
          <strong style={{ color: "hsl(var(--footer-fg))" }}>Disclosure.</strong>{" "}
          AnxietyResource is published by{" "}
          <ShrinkMDLink
            style={{ color: "hsl(var(--brand))", textDecoration: "underline" }}
          >
            shrinkMD Publishing
          </ShrinkMDLink>{" "}
          and medically edited by Shariq Refai, MD, MBA, who founded{" "}
          <ShrinkMDLink
            style={{ color: "hsl(var(--brand))", textDecoration: "underline" }}
          >
            shrinkMD
          </ShrinkMDLink>
          , a telepsychiatry practice. This site carries no advertising and
          no referral or affiliate revenue. Read our{" "}
          <a
            href="/editorial-standards#conflicts-of-interest"
            style={{ color: "hsl(var(--brand))", textDecoration: "underline" }}
          >
            editorial standards
          </a>
          .
        </p>
      </div>
    </section>
  );
}
